export default __webpack_public_path__ + "static/home_page_placeholder-ce7843c77685276d3af23c5f9b404ec4.jpg";